import { methodGet, methodPost, methodPatch, methodDelete } from './methods';
import { API_INFO } from '../constants';

export const getPosts = async (query) => {
  return methodGet(API_INFO + 'blog/posts/', query);
};

export const getBlogPosts = async (payload) => {
  const { year, month, day, slug } = payload;
  return methodGet(API_INFO + `blog/posts/${year}/${month}/${day}/${slug}`);
};

export const getAllRelatedPost = async (id) => {
  return methodGet(API_INFO + `blog/posts/${id}/related/`);
}

export const createPost = async (payload) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  return methodPost(API_INFO + 'blog/posts/', payload, config);
};

export const getDetailPost = async (id) => {
  return methodGet(API_INFO + `blog/posts/${id}/`);
};

export const editPost = async (id, payload) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  return methodPatch(API_INFO + `blog/posts/${id}/`, payload, config);
};

export const deletePost = async (id) => {
  return methodDelete(API_INFO + `blog/posts/${id}/`);
};

export const getBlogCategories = async (query) => {
  return methodGet(API_INFO + 'blog/categories/', query);
};

export const getBlogCategoriesNotPaginated = async (query) => {
  return methodGet(API_INFO + 'blog/categories/categories-not-paginated', query);
};

export const createBlogCategory = async (category) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  return methodPost(API_INFO + 'blog/categories/', category, config);
};

export const getDetailBlogCategory = async (id) => {
  return methodGet(API_INFO + `blog/categories/${id}/`);
};

export const editBlogCategory = async (id, payload) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  return methodPatch(API_INFO + `blog/categories/${id}/`, payload, config);
};

export const deleteBlogCategory = async (id) => {
  return methodDelete(API_INFO + `blog/categories/${id}/`);
};
